import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DropdownOptions } from '../../utilities/commonUtilities';

interface EquipmentCatalogState {
    dropdownOption: DropdownOptions;
    catalog: {
        data: any[];
        count: number;
    };
    exportCatalogData: {
        success: boolean,
        message: string,
        affectedRows: number,
        errors: any[],
    };
    file: {
        fileData: File | null;
        fileName: string;
        fileSize: number;
        uploadProgress: number;
        isSuccess: boolean;
        isUploading: boolean;
        impactedRows?: number;
    };
    fileError: {
        isValid: boolean;
        error: any;
    };
    AuditLog: {
        data: any[];
        count: number;
    };
    loading?: boolean;
    error?: string;
};

export const initialState: EquipmentCatalogState = {
    dropdownOption: { id: "0", name: "DR cables" },
    catalog: {
        data: [],
        count: 0
    },
    exportCatalogData: {
        success: true,
        message: "",
        affectedRows: 0,
        errors: []
    },
    file: {
        fileData: null,
        fileName: "",
        fileSize: 0,
        uploadProgress: 0,
        isSuccess: false,
        isUploading: false,
        impactedRows: 0,
    },
    fileError: {
        isValid: true,
        error: [],
    },
    AuditLog: {
        data: [],
        count: 0
    },
    loading: false,
    error: undefined
};

export const getEquipmentCatalog = createAction("equipmentCatalog/getEquipmentCatalog");
export const getExportEquipmentCatalog = createAction("equipmentCatalog/getExportEquipmentCatalog");
export const validateUploadEquipment = createAction("equipmentCatalog/validateUploadEquipment");
export const updateExportEquipmentCatalog = createAction("equipmentCatalog/updateExportEquipmentCatalog");
export const getAuditLog = createAction("equipmentCatalog/getAuditLog");

const equipmentCatalogSlice = createSlice({
    name: 'equipmentCatalog',
    initialState,
    reducers: {
        setDropdownOption: (state, action) => {
            state.dropdownOption = action?.payload;
        },
        setCatalogdata: (state, action) => {
            state.catalog.data = action?.payload?.items;
            state.catalog.count = action?.payload?.totalCount
        },
        setExportEquipmentCatalog: (state, action) => {
            state.exportCatalogData = action?.payload;
        },
        setFile: (state, action) => {
            state.file.fileData = action?.payload;
        },
        setFileUploadProgress: (state, action) => {
            state.file.uploadProgress = action?.payload;
        },
        setFileUploadSuccess: (state, action) => {
            state.file = {
                ...state.file,
                ...action?.payload,
            };
        },
        setFileError: (state, action) => {
            state.fileError.error = action?.payload?.error;
            state.fileError.isValid = action?.payload?.isValid;
        },
        setFileUploading: (state, action) => {
            state.file.isUploading = action?.payload;
        },
        setAuditLog: (state, action) => {
            state.AuditLog.data = action?.payload?.data?.length > 0 ? action?.payload?.data.map((item: any) => ({
                ...Object.fromEntries(
                    Object.entries(item?.auditLog || {}).map(([key, value]) => [`audit_${key}`, value])
                ),
                ...Object.fromEntries(
                    Object.entries(item?.catalogItem || {}).map(([key, value]) => [`catalog_${key}`, value])
                ),
            })) : action?.payload?.data;
            state.AuditLog.count = action.payload?.totalCount;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action?.payload;
        },
        setError: (state, action: PayloadAction<string>) => {
            state.error = action?.payload;
        }
    },
});

export const {
    setDropdownOption,
    setCatalogdata,
    setExportEquipmentCatalog,
    setFile,
    setFileUploading,
    setFileUploadProgress,
    setFileUploadSuccess,
    setFileError,
    setAuditLog,
    setLoading,
    setError,
} = equipmentCatalogSlice.actions;

export default equipmentCatalogSlice.reducer;